import React, { forwardRef, useState } from 'react';
import { BorderBeam } from 'border-beam';

const ActionBeam = ({
  children,
  animated,
  disabled = false,
  busy = false,
  size = 'sm',
  className = '',
}) => {
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);

  return (
    <BorderBeam
      className={`chatbot-beam ${className}`.trim()}
      size={busy ? 'pulse-inner' : size}
      colorVariant="ocean"
      theme="dark"
      staticColors
      strength={busy ? 0.5 : 0.4}
      duration={3.6}
      active={animated && (busy || (!disabled && (hovered || focused)))}
      data-motion={animated ? 'on' : 'off'}
      onPointerEnter={(event) => setHovered(event.pointerType !== 'touch')}
      onPointerLeave={() => setHovered(false)}
      onFocusCapture={() => setFocused(true)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false);
      }}
    >
      {children}
    </BorderBeam>
  );
};

export const BeamButton = forwardRef(function BeamButton({
  as: Component = 'button', animated, children, ...props
}, ref) {
  return (
    <ActionBeam animated={animated} disabled={props.disabled} busy={props['aria-busy']}>
      <Component ref={ref} {...props}>{children}</Component>
    </ActionBeam>
  );
});

export default ActionBeam;
